import {Box, CircularProgress, Stack, Typography} from "@mui/material";
import {useEffect, useState} from "react";
import {getMetaLoadouts} from "../../api/API";
import {ProfileLoadout} from "../../pages/profile/ProfileLoadouts";
import MobileAd, {MobileSlots} from "../../components/ads/MobileAd";

const Loadouts = ({loadouts}) => {
    if ((loadouts ?? []).length === 0) {
        return <Typography variant='h4'
                           sx={{
                               pb: '15px',
                               pl: {xs: 0, md: '10px'},
                               width: {xs: '100%', md: '80%'},
                               textAlign: 'center',
                               mt: {xs: '10px', md: '20px'},
                               fontStyle: 'oblique',
                               fontSize: {xs: '1.2rem', md: '1.5rem'},
                           }}>
            No featured loadouts yet.
        </Typography>
    }
    return [
        <Typography variant='h4'
                    sx={{
                        mb: '5px',
                        width: {xs: '100%', md: '85%'},
                        textAlign: {xs: 'center', md: 'left'},
                        position: 'sticky',
                        mt: {xs: '10px', md: '20px'},
                        fontStyle: 'oblique',
                        fontSize: {xs: '1.6rem', md: '2rem'},
                    }}>
            Featured Loadouts
        </Typography>,
        <Stack width={{xs: '100%', md: '85%'}} minWidth={{xs: null, md: '900px'}}>
            {loadouts.map((loadout) => <ProfileLoadout isOwnProfile={false} loadout={loadout} showImage={false}/>)}
        </Stack>
    ];
}

const FeaturedLoadouts = ({weapon, category}) => {
    const [loadouts, setLoadouts] = useState("loading")

    useEffect(() => {
        if (weapon == null) return
        getMetaLoadouts(weapon, category)
            .then(response => setLoadouts(response))
    }, [weapon])

    if (loadouts === "loading") return <CircularProgress/>

    return (
        <Stack alignItems='center' width='100%'>
            <Box sx={{
                p: '5px',
                m: {xs: 0, md: '5px 10px'},
                maxWidth: {xs: '90%', md: '70%'},
                borderRadius: '3px',
                backgroundColor: 'rgba(0,0,0,0.2)',
                display: loadouts.description ? null : 'none'
            }}>
                <Typography textAlign='center' fontStyle='oblique'
                            fontSize={{xs: '0.8rem', md: '1rem'}}>
                    {loadouts.description}
                </Typography>
            </Box>
            <MobileAd slot={MobileSlots.HORIZONTAL_5}/>
            <Loadouts loadouts={loadouts.loadouts}/>
        </Stack>
    )
}
export default FeaturedLoadouts